import { render, staticRenderFns } from "./basindic.vue?vue&type=template&id=7f0772a0&scoped=true&"
import script from "./basindic.vue?vue&type=script&lang=js&"
export * from "./basindic.vue?vue&type=script&lang=js&"
import style0 from "./basindic.vue?vue&type=style&index=0&id=7f0772a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0772a0",
  null
  
)

export default component.exports